import React from 'react';
import { Tooltip, OverlayTrigger } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const NameTooltip = ({text}) => {
    return (
        <OverlayTrigger placement="right" overlay={makeTooltip(text)}>
            <div>{text}</div>
        </OverlayTrigger>);
};

const makeTooltip = text => {
    return (
        <Tooltip id="tooltip" container={this}>
            {text}
        </Tooltip>
    );
};

NameTooltip.propTypes = {
    text: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/table/NameTooltip.js